/**
 * Permission checks for the new VAR-based adjustments app.
 *
 * The backend exposes a single "Invoicing" permission (customerApplication
 * "Google") with the four standard action flags. Route access additionally
 * requires the `adjustmentsTab` / `newAdjustmentsApp` LD flags — see
 * src/apps/google/routes.tsx and src/areas/adjustments/AdjustmentsSwitch.tsx.
 */

export type PermissionAction = "create" | "read" | "edit" | "delete";

export const adjPermission = (action: PermissionAction) => ({
    customerApplication: "Google",
    permissionName: "Adjustments",
    action,
});

export const UNAUTHORIZED_TOOLTIP = "You are not authorized to perform this action";
